/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerUsers.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Users
 *
 *  Author:     Norman J. Nolasco [ Telmetrix ]
 *  
 *  Created:    Thursday, July 21, 2022 - 3:10 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/21/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Telmetrix - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    USER_UPDATE_COMPANYID, USER_UPDATE_STATUSID
} from '../constants/actionTypeUsers';

const defaultState = {
    companyid_f: 0,
    statusid_f: 0
};

const reducerUsers = (state = defaultState, action) => {
    switch (action.type) {
        case USER_UPDATE_COMPANYID:
            return {
                ...state,
                companyid_f: parseInt(action.payload) ? parseInt(action.payload) : 0,
            }
         case USER_UPDATE_STATUSID:
            return {
                ...state,
                statusid_f: parseInt(action.payload) ? parseInt(action.payload) : 0,
            }
        default:
            return state;
    }
};

export default reducerUsers;
